export default class LandingPageTemplate {
    public offerLPTemplateId: number;
    public offerLPTemplateName: string;
    public description: string;

    constructor(obj?: any) {
        if(obj) {
            this.offerLPTemplateId = obj.offerLPTemplateId;
            this.offerLPTemplateName = obj.offerLPTemplateName;
            this.description = obj.description;
        }
    }
}